define('views/pages/news/news',[
    'jquery',
    'views/base/view',
    'views/base/collection',
    'text!templates/pages/news/news-row.ejs'
], function($, View, CollectionView, templateNewsItem) {
    'use strict';

    var NewsItemView = View.extend({
        template: templateNewsItem,
        className: 'news',
        render: function() {
            View.prototype.render.apply(this, arguments);
            if (!this.model.get('Readed')) {
                this.$el.addClass('news-new');
            }
        }
    });

    var NewsListView = CollectionView.extend({
        itemView: NewsItemView,
        autoRender: false,
        className: 'news-list',
        region: 'news-list'
    });

    return NewsListView;
});

